<template>

  <t-page>


    <t-page-form card :submit-text="'Senha de Acesso'"
                 :title="'Alterar Senha de Acesso'"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">


      <t-msg info v-if="showChangeTempPassMsg" big> Precisamos que você altere sua senha inicial temporária</t-msg>

      <h4>{{ user.name }}</h4>


      <div v-if="pageFormIsLoaded">

        <div v-if="user.enableAccessCode">

          <t-input v-model="form.oldPassword" password :add-error="error.oldPassword" label="PIN atual" required/>

          <t-input v-model="form.newPassword" password only-numbers min-length="6" max-length="6" label="Novo PIN"
                   required/>

          <t-input v-model="confirmPassword" password only-numbers min-length="6" max-length="6"
                   :add-error="msgPasswordNotEqual" label="Confirme o novo PIN"
                   required/>

        </div>

        <div v-else>

          <t-input v-model="form.oldPassword" password :add-error="error.oldPassword" label="Senha atual" required/>

          <t-input v-model="form.newPassword" password-security :add-error="error.newPassword"
                   label="Nova senha"
                   required/>

          <t-input v-model="confirmPassword" :add-error="msgPasswordNotEqual" password label="Confirme a nova senha"
                   required/>
        </div>

      </div>


    </t-page-form>

  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import myUserService from "@/services/modules/general/MyUser.service";
import {crudGeneral} from "@/services/resource/GeneralCRUD.service";
import ui from "@/assets/scripts/ui";

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'MyUserChangePassword',
  data() {
    return {
      path: "general/my-user/changePassword", //Utilizar somente quando fora do padrão
      generalResource: true, //Página de recurso geral
      genKey: false, //Utilizar quando desejar gerar chave temporária
      fieldKey: "",
      pageTitle: "Alteração de Senha",
      user: {
        username: "",
        name: "",
        profile: "",
        department: "",
        initials: "",
        enableAccessCode: false,
      },
      form: {
        oldPassword: "",
        newPIN: "",
        newPassword: "",
      },
      error: {//Campos que podem receber retorno de erro do backend
        oldPassword: "",
        newPassword: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      confirmPassword: "",
      showChangeTempPassMsg: false,
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

      if (this.$route.query.tempPassword) {
        this.showChangeTempPassMsg = true;
      }


    },
    async mountedContinued() {

      this.command = 'update'

      await myUserService.get().then((my_user) => {
        this.user = my_user.user
        this.pageFormIsLoaded = true
      }).catch(error => this.responseError(error))


    },
    async onSubmit() {


      if (this.confirmPassword === this.form.newPassword) {

        this.status = "sending"

        //Crud enviado, por tanto será feito de forma automatica a inclusão e alteração
        await crudGeneral.save(this.getPath(), this.command, this.form).then(() => {

          ui.msg(this, 'Informação', 'Senha atualizada com sucesso, será necessário realizar login novamente', () => {
            ui.logout(this)
          })

        }).catch(error => {

          if (error.response) {

            if (error.response.status === 401) {
              ui.msg(this, 'Informação', 'Senha atual informada não está correta')
            } else if (error.response.status === 500) {
              ui.msg(this, 'Informação', error.response.data.message)
            }

            this.form.oldPassword = ''
            this.form.newPassword = ''
            this.confirmPassword = ''

            this.status = "subject"

          }

        })

      } else {

        ui.msg(this, 'Senha não igual a confirmação', 'Senha de confirmação diferente da nova senha. Para continuar é necessário que ambas sejam idênticas.')

      }


    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    //--------------------------------------------------------------------------------------

  },
  computed: {

    msgPasswordNotEqual() {
      if (this.form.newPassword !== '' && this.form.newPassword !== this.confirmPassword) {
        return 'Senha de confirmação diferente da nova senha'
      } else {
        return ""
      }
    }

  },

  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(false, false)

    await this.mountedContinued()

  },

}
</script>
